import { ICatalog } from "../../store/catalog/repository/ICatalog";
import Section from "../section/section";
import CategoryCard from "../categoryCard/categoryCard";
import "./categoriesList.scss";
import BreadcrumbsItem from "../breadcrumbs/breadcrumbsItem";
import { useSelector } from "react-redux";
import { selectCatalog } from "../../store/catalog/repository/selectors";
import { useMemo } from "react";
import { breadcrumbsItems } from "../../utils/findCategoryPathByName";
import { useParams } from "react-router-dom";

const CategoriesList = ({ childCategories, name, description }: ICatalog) => {
  const catalog: ICatalog[] = useSelector(selectCatalog);
  const { id } = useParams<{ id: string }>();
  const breadcrumbs = breadcrumbsItems(catalog, Number(id));
  return (
    <Section className="categories_list">
      <BreadcrumbsItem items={breadcrumbs} />

      {name && <h1 className="categories_list__title">{name}</h1>}
      <div className="categories_list__wrap">
        <ul className="categories_list__body">
          {childCategories &&
            childCategories.map((card) => (
              <li key={card.id} className="categories_list__item">
                <CategoryCard {...card} />
              </li>
            ))}
        </ul>
      </div>
      {description && description !== "" && (
        <div className="categories_list__descr">{description}</div>
      )}
    </Section>
  );
};

export default CategoriesList;
